import { render, staticRenderFns } from "./Wallboards.vue?vue&type=template&id=d1f1de66&"
import script from "./Wallboards.vue?vue&type=script&lang=js&"
export * from "./Wallboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports